import React from 'react';
import './App.css';
import { Box } from '@mui/material';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import BookingPortal from './Components/Booking/BookingPortal';
import { BookingProvider } from './Context/BookingContext';
import Navbar from './Components/Navbar/Navbar';
import { Home } from './Components/Pages/Home';
import { AboutUs } from './Components/Pages/AboutUs';
import { ContactUs } from './Components/Pages/ContactUs';
import { Events } from './Components/Pages/Events';
import { Membership } from './Components/Pages/Membership';
import { Links } from './Components/Pages/Links';
import { MembersOnly } from './Components/Pages/MembersOnly';
import { Trips } from './Components/Pages/Trips';
import Footer from './Components/Footer';
import Booking from './Components/Pages/Booking';

// const Booking = () => {
//   return (
//     <BookingProvider>
//       <BookingPortal />
//     </BookingProvider>
//   );
// };

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: 'calc(100vh - 200px)',
          }}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/events" element={<Events />} />
            <Route path="/trips" element={<Trips />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/booking" element={<Booking />} />
            {/* <Route path="/membersonly" element={<MembersOnly />} />
            <Route path="/booking" element={
              <BookingProvider>
                <BookingPortal />
              </BookingProvider>} /> */}
            <Route path="/links" element={<Links />} />
            <Route path="*" element={<h1>404 Not Found</h1>} />
          </Routes>
        </Box>
        <Footer />
      </Router >
    </>
  );
}

export default App;
